import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["type", "value", "maxLength"]

import { computed, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: [String, Number],
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  validationError: {
    type: String,
    default: null,
  },
  mask: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'text',
  },
  maxLength: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props





const { mask, type: propType } = toRefs(props);

const type = computed((): string =>
  propType ? propType.value : mask.value ? 'password' : 'text'
);

function onUpdate(event: Event) {
  const element = event.target as HTMLInputElement;
  emit('update:modelValue', element.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass([
        'text-xs absolute -top-2 left-2 bg-white px-1',
        {
          'text-red-400': __props.validationError,
          ' text-gray-400': !__props.validationError,
        },
      ])
    }, _toDisplayString(__props.title), 3),
    _createElementVNode("input", {
      type: _unref(type),
      value: __props.modelValue,
      onInput: onUpdate,
      maxLength: __props.maxLength,
      class: _normalizeClass([
        'border w-full text-lg py-2 px-1 rounded',
        {
          'border-red-400': __props.validationError,
        },
      ])
    }, null, 42, _hoisted_2),
    _withDirectives(_createElementVNode("div", { class: "text-sm text-left text-red-400" }, _toDisplayString(__props.validationError), 513), [
      [_vShow, __props.validationError]
    ])
  ]))
}
}

})